import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ThemeService } from '@services/theme.service';
import { WifiConnectionLoaderService } from '@services/wifi-connection-loader.service';

@Component({
  selector: 'app-wifi-connection-loader',
  templateUrl: './wifi-connection-loader.component.html',
  styleUrls: ['./wifi-connection-loader.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class WifiConnectionLoaderComponent {
  theme!: any;
  isLoading$: Observable<boolean>;

  constructor(
    private themeService: ThemeService,
    private wifiConnectionLoaderService: WifiConnectionLoaderService
  ) {
    this.isLoading$ = this.wifiConnectionLoaderService.loading$;
    this.themeService.getCurrentTheme().subscribe(theme => {
      this.theme = theme;
    });
  }

  close(): void {
    this.wifiConnectionLoaderService.hide();
  }
}
